module.exports = __webpack_public_path__ + "static/media/18ECA44.0817a6f3.jpg";